import React, { useEffect, useState, useCallback } from "react";
import TaskForm from "../components/TaskForm";
import TaskList from "../components/TaskList";
import { taskService } from "../services/api";
import "../styles/Dashboard.css";

const Dashboard = ({ user, onLogout }) => {
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchTasks = useCallback(async () => {
    setLoading(true);
    try {
      const res = await taskService.getTasks(filter || undefined);
      setTasks(res.data);
    } catch (err) {
      alert("Error fetching tasks");
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div>
          <h1>Task Manager</h1>
          <p>Welcome, {user?.name}!</p>
        </div>
        <button onClick={onLogout} className="logout-btn">
          Logout
        </button>
      </header>

      <div className="dashboard-content">
        <div className="filters">
          <button
            className={filter === "" ? "active" : ""}
            onClick={() => setFilter("")}
          >
            All Tasks
          </button>
          <button
            className={filter === "pending" ? "active" : ""}
            onClick={() => setFilter("pending")}
          >
            Pending
          </button>
          <button
            className={filter === "in-progress" ? "active" : ""}
            onClick={() => setFilter("in-progress")}
          >
            In Progress
          </button>
          <button
            className={filter === "completed" ? "active" : ""}
            onClick={() => setFilter("completed")}
          >
            Completed
          </button>
        </div>

        <div className="main-content">
          <TaskForm onTaskCreated={fetchTasks} />
          {loading ? (
            <p>Loading...</p>
          ) : (
            <TaskList tasks={tasks} onTaskUpdated={fetchTasks} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
